var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 28,
    viewBox: "0 0 8 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.869141 16.5652C0.869141 18.2221 2.21229 19.5652 3.86914 19.5652H4.13001C5.78686 19.5652 7.13001 18.2221 7.13001 16.5652L7.13001 3.08697C7.13001 1.43012 5.78687 0.0869751 4.13001 0.0869751H3.86914C2.21229 0.0869751 0.869141 1.43012 0.869141 3.08697V16.5652ZM3.99958 27.9131C5.72847 27.9131 7.13001 26.5115 7.13001 24.7826C7.13001 23.0537 5.72847 21.6522 3.99958 21.6522C2.27068 21.6522 0.869141 23.0537 0.869141 24.7826C0.869141 26.5115 2.27068 27.9131 3.99958 27.9131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.6ffd908063703dc6a18c68805178bb3c.svg";
export { ForwardRef as ReactComponent };